<template>
  <footer
      :class="{ [`footer-${type}`]: type }"
      :data-background-color="backgroundColor"
      class="footer"
  >
    <div class="container">
      <nav>
        <ul>
          <li class="nav-item">
            <a
                class="nav-link"
                href="#/aboutus"
            >
              <i class="now-ui-icons education_atom"></i>
              <p>About Us</p>
            </a>
          </li>
          <li class="nav-item">
            <a
                class="nav-link"
                href="#/careers"
            >
              <i class="now-ui-icons business_briefcase-24"></i>
              <p>Careers</p>
            </a>
          </li>
          <li class="nav-item">
            <a
                class="nav-link"
                href="#/contact"
            >
              <i class="now-ui-icons ui-1_email-85"></i>
              <p>Contact Us</p>
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }}, Designed by
        <a href="http:///www.ai-integration.com" rel="noopener" target="_blank"
        >AI Integration</a
        >. Coded by
        <a href="http://www.ai-integration.com" rel="noopener" target="_blank"
        >AI Integration</a
        >.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>
